$(document).ready(function() {
 
  $('.hm-banner-slider').owlCarousel({
    autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:false,
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    singleItem:true,
    animateOut: 'fadeOut',
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})
 
});


// img popup script
document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("imgModal");
  const modalImg = document.getElementById("modalImg");
  const closeBtn = document.querySelector(".img-modal-close");
  const body = document.body;

  if (!modal || !modalImg || !closeBtn) return;

  document.querySelectorAll(".img-popup-trig img").forEach(img => {
    img.style.cursor = "pointer";

    img.addEventListener("click", function () {
      modal.style.display = "flex";
      modalImg.src = this.src;

      // add class when popup opens
      body.classList.add("img-popup-open");
    });
  });

  function closeModal() {
    modal.style.display = "none";

    // remove class when popup closes
    body.classList.remove("img-popup-open");
  }

  closeBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

});

// expandable product description (fetches full text, since theme truncates it to 230 chars)
document.addEventListener("DOMContentLoaded", function () {
  var descEl = document.querySelector(".xo-product-info-content__description");
  if (!descEl) return;

  var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!match) return;
  var handle = match[1];

  var style = document.createElement("style");
  style.textContent =
    ".xo-description-expand-wrap[data-expanded='false'] .xo-product-info-content__description {" +
    "display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;}" +
    ".xo-product-info-content__description {color: #000 !important; opacity: 1 !important;}" +
    ".xo-description-expand-toggle {display: inline-block; background: none; border: none; padding: 0;" +
    "margin-top: 0.6rem; font: inherit; font-weight: 600; text-decoration: underline; cursor: pointer; color: inherit;}";
  document.head.appendChild(style);

  fetch("/products/" + handle + ".js")
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (product) {
      if (!product || !product.description) return;

      var temp = document.createElement("div");
      temp.innerHTML = product.description;
      var plainLength = (temp.textContent || temp.innerText || "").trim().length;

      if (!plainLength || plainLength <= 230) return;

      // Swap the plain <p> for a <div> so multi-paragraph HTML (bold, line breaks, lists) renders correctly
      var newDescEl = document.createElement("div");
      newDescEl.className = descEl.className;
      newDescEl.innerHTML = product.description;
      descEl.parentNode.replaceChild(newDescEl, descEl);

      var wrap = document.createElement("div");
      wrap.className = "xo-description-expand-wrap";
      wrap.setAttribute("data-expanded", "false");
      newDescEl.parentNode.insertBefore(wrap, newDescEl);
      wrap.appendChild(newDescEl);

      var toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "xo-description-expand-toggle";
      toggle.textContent = "Read more";
      wrap.appendChild(toggle);

      toggle.addEventListener("click", function () {
        var expanded = wrap.getAttribute("data-expanded") === "true";
        wrap.setAttribute("data-expanded", expanded ? "false" : "true");
        toggle.textContent = expanded ? "Read more" : "Read less";
      });
    })
    .catch(function () {});
});

// Bundle widget description HTML restore - UpState, 2026-07-21
// The Simple Bundles build-your-own-bundle widget renders descriptions as plain
// text (HTML stripped): the bundle's own description in the cart panel
// (.byob-mini-cart__subtitle) and each child product's description in the
// "See full details" modal (.byob-options-modal__desc). This watches for those
// elements and swaps in the real description HTML from Shopify's product JSON.
if (window.location.pathname.indexOf("/products/") !== -1) {
  (function () {
    var cache = {};
    function fetchProduct(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch("/products/" + handle + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return cache[handle];
    }
    function textOf(html) {
      var d = document.createElement("div");
      d.innerHTML = html;
      return (d.textContent || "").replace(/\s+/g, " ").trim();
    }
    function applyHtml(el, html) {
      if (!el || !html || el.dataset.upstateRich) return;
      var current = (el.textContent || "").replace(/\s+/g, " ").trim();
      var target = textOf(html);
      if (!current || !target) return;
      if (current.slice(0, 40) !== target.slice(0, 40)) return; // wrong product, leave it alone
      el.dataset.upstateRich = "1";
      el.innerHTML = html;
    }
    function fixCartPanel() {
      var el = document.querySelector(".byob-mini-cart__subtitle");
      if (!el || el.dataset.upstateRich) return;
      var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (!match) return;
      fetchProduct(match[1]).then(function (p) {
        if (p) applyHtml(document.querySelector(".byob-mini-cart__subtitle"), p.description);
      });
    }
    function fixModal() {
      document.querySelectorAll(".byob-options-modal").forEach(function (modal) {
        var desc = modal.querySelector(".byob-options-modal__desc");
        if (!desc || desc.dataset.upstateRich) return;
        var link = modal.querySelector(".byob-options-modal__details-link");
        var href = link ? link.getAttribute("href") || "" : "";
        var match = href.match(/\/products\/([^\/?#]+)/);
        if (!match) return;
        fetchProduct(match[1]).then(function (p) {
          if (p) applyHtml(desc, p.description);
        });
      });
    }
    document.addEventListener("DOMContentLoaded", function () {
      new MutationObserver(function () {
        fixCartPanel();
        fixModal();
      }).observe(document.body, { childList: true, subtree: true });
      fixCartPanel();
      fixModal();
    });
  })();
}